export const SafeAudioContext =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  globalThis.AudioContext || (globalThis as any).webkitAudioContext || null;
